<template>
  <div>
    <div v-if="!value && !showInput" @click="handleShowInput" :class="`${name}-textarea`" class="add-textarea-box row items-center">
      <q-icon name="add"/>
      <span>{{ boxText || $t('add_textarea') }}</span>
      &nbsp;
      <span
        v-if="additionalBoxText"
        @click="$emit('clicked')"
        class="add-textarea-box__additional-text"
      >{{ additionalBoxText }}</span>
    </div>

    <q-input
        v-if="(value || showInput) && !useMarkdown"
        :value="value"
        @input="update"
        @blur="handleInputBlur"
        type="textarea"
        :placeholder="placeholder || $t('text')"
        :name="name"
        autofocus
    />

    <q-editor
      v-else-if="(value || showInput) && useMarkdown"
      ref="editor"
      :value="value"
      :toolbar="toolbar"
      toolbar-bg="white"
      toolbar-text-color="grey-7"
      class="q-mt-lg round-borders"
      style="overflow: hidden"
      toolbar-flat
      autofocus
      @blur="handleInputBlur"
      @input="update"
    />
  </div>
</template>

<script>
  import QEditor from 'components/Common/Inputs/QEditorWrapped'

  export default {
    components: {
      QEditor
    },

    data () {
      return {
        showInput: false
      }
    },

    props: {
      name: {
        type: String,
        required: true
      },

      placeholder: {
        type: String,
        required: false
      },

      boxText: {
        type: String,
        required: false
      },

      additionalBoxText: {
        type: String,
        required: false
      },

      useMarkdown: {
        type: Boolean,
        required: false
      },

      value: {
        validator: val => val === null || typeof val === 'string',
        required: true
      }
    },

    computed: {
      toolbar () {
        return [
          ['bold', 'italic'],
          ['unordered', 'ordered'],
          ['removeFormat']
        ]
      }
    },

    methods: {
      handleShowInput () {
        this.showInput = true
      },

      handleInputBlur () {
        if (this.value === null || this.value === '') {
          this.showInput = false
          this.editor = null
        }
      },

      update (val) {
        if (val === '<br>' || val === '<div><br></div>') {
          this.$emit('input', '')
        } else {
          this.$emit('input', val)
        }
      }
    }
  }
</script>

<style lang="stylus">
  .add-textarea-box
    border: 1px dotted #A0AEC0
    margin: 1rem 0
    padding: 1rem
    display: flex
    justify-content: center
    font-size: 0.875rem
    cursor: pointer
    color: #718096

  .add-textarea-box:hover
    border: 1px dotted #718096
    color: #4a5568

  .add-textarea-box__additional-text
    text-decoration: underline

    &:hover
      color: #2d3748
      font-weight: bold
</style>
